import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function getPackCodeReport(
    country,
    category,
    brand,
    fromDate,
    toDate,
    gigyaId = '',
    packCode = '',
    eventType = '',
    start = 0,
    limit = 10
) {
    let path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/pack-code?fromDate=${fromDate}&toDate=${toDate}&start=${start}&limit=${limit}`;

    if (gigyaId) {
        path += `&gigyaId=${gigyaId}`;
    }

    if (packCode) {
        path += `&packCode=${packCode}`;
    }

    if (eventType) {
        path += `&eventType=${eventType}`;
    }

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
